import actions from './actions'

const initialState = {
  globalRouteMatch: {
    params: {},
  },
}

export default function menuReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
